
import AiAgent from "./AiAgent";

export default AiAgent;
